import React from 'react'
import { Stack } from '@mui/material'
import {
  CostimizerFeatureCard,
  CostimizerFeatureCardData,
  SectionHeader,
  SectionWrapper,
} from '@components/common'
import { SectionHeaderData } from '@components/common/SectionHeader'
import { getStyles } from '@utils/styles'
import defaultStyles from './styles'

export type HighlightSectionData = {
  cardsData: CostimizerFeatureCardData[]
  sectionHeaderData?: SectionHeaderData
  darkBg?: boolean
}

export type HighlightSectionProps = HighlightSectionData & {
  showDivider?: 'top' | 'bottom' | 'both' | 'none'
  alternateSectionBg?: boolean
}

export function HighlightSection({
  cardsData,
  sectionHeaderData,
  showDivider,
  darkBg = false,
  alternateSectionBg = false,
}: HighlightSectionProps) {
  const styles = getStyles(defaultStyles)

  return (
    <SectionWrapper
      showDivider={showDivider}
      alternateSectionBg={alternateSectionBg}
    >
      <Stack spacing={6}>
        {sectionHeaderData && <SectionHeader {...sectionHeaderData} />}
        {cardsData.map((cardData) => {
          return (
            <SectionWrapper
              key={cardData.title}
              disablePadding
              alternateBg={darkBg}
              alternateSectionBg={alternateSectionBg}
              {...styles('cardWrapper', {
                borderColor: darkBg ? 'border.contrastText' : 'border.dark',
              })}
              csx={{ wrapper: { borderRadius: '16px' } }}
            >
              <CostimizerFeatureCard
                {...cardData}
                isReverse
                csx={{ image: styles('image').sx }}
                darkBg={darkBg}
              />
            </SectionWrapper>
          )
        })}
      </Stack>
    </SectionWrapper>
  )
}
